import React, { useState } from 'react';
import { FileUpload } from 'primereact/fileupload';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { uploadFile } from './helper';

export type ModalUploadFileProps = OpenControls & {
  onChangeAttachments: (results: any[]) => void;
  extraConfig: any
};

const ModalUploadFile = ({ handleClose, isOpen, onChangeAttachments, extraConfig }: ModalUploadFileProps) => {
  const [isUploading, setIsUploading] = useState(false);
  const {auto = false, accept='', maxFileSize='', multiple=true, previewWidth=''} = extraConfig
  console.log('**ModalUplodFile**', accept, extraConfig)
  const handleFileUpload = async (event) => {
    setIsUploading(true);
    const promises: any[] = (event?.files || []).map((file) => uploadFile(file));
    Promise.all(promises)
      .then((results) => {
        setIsUploading(false);
        console.log('Results from Upload', results);
        onChangeAttachments(results);
        handleClose();
      })
      .catch((err) => {
        console.log('Error on File Upload', err.toString());
        setIsUploading(false);
        onChangeAttachments([]);
        handleClose();
      });
  };

  const renderFooter = () => <div>{/*<Button label="Close" onClick={handleClose} className="button-text" />*/}</div>;
  const chooseOptions = { label: 'Choose', icon: 'pi pi-fw pi-plus' };
  const uploadOptions = { label: 'Upload', icon: 'pi pi-upload', className: 'p-button-success' };
  const cancelOptions = { label: 'Cancel', icon: 'pi pi-times', className: 'p-button-danger' };
  return (
    <Dialog
      visible={isOpen}
      onHide={handleClose}
      header="Upload Files from your Computer"
      footer={renderFooter()}
      breakpoints={{ '960px': '75vw', '640px': '100vw' }}
      style={{ width: '50vw' }}
      draggable={false}
    >
      <FileUpload
        name="attachments[]"
        url="#"
        auto={auto}
        multiple={multiple}
        accept={accept || '*'}
        maxFileSize={maxFileSize ? Math.min(24000000,Number(`${maxFileSize}`)) : 24000000}
        customUpload
        uploadHandler={handleFileUpload}
        previewWidth={Number(`${previewWidth || 50}`)}
        emptyTemplate={<p className="m-0">Drag and drop files here to upload.</p>}
        chooseOptions={chooseOptions}
        uploadOptions={uploadOptions}
        cancelOptions={cancelOptions}
      />
      {isUploading && (
        <div className="card">
          <div className="flex flex-wrap align-items-center justify-content-center card-container ">
            <span style={{ fontWeight: 700 }}>
              <ProgressSpinner />
              Uploading Files...
            </span>
          </div>
        </div>
      )}
    </Dialog>
  );
};

export default ModalUploadFile;
